import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Location } from '@angular/common';
import { BehaviorSubject, combineLatest, Subscription } from 'rxjs';
import { distinctUntilChanged, map, filter } from 'rxjs/operators';
import { TableType } from '../../../shared/enums';
import { IsNotCalibratedReasonService } from 'src/app/core/services/is-not-calibrated-reason.service';

@Component({
    standalone: false,
    selector: 'app-view',
    templateUrl: './app-view.component.html',
    styleUrls: ['./app-view.component.scss']

})
export class AppViewComponent implements OnInit, OnDestroy {
    private readonly tabChangeSubject = new BehaviorSubject<string>(null);
    private readonly subTabChangeSubject = new BehaviorSubject<string>(null);
    private subscriptions: Subscription[] = [];

    readonly currentTab = this.tabChangeSubject.asObservable().pipe(distinctUntilChanged());
    readonly currentSubTab = this.subTabChangeSubject.asObservable().pipe(distinctUntilChanged());

    tableType: any = TableType;

    constructor(
        private readonly router: Router,
        private readonly route: ActivatedRoute,
        private readonly location: Location,
        private readonly isNotCalibratedReasonService: IsNotCalibratedReasonService,
    ) {}

    ngOnInit() {
        this.mapTabToRouter();
        this.subscriptions.push(
            this.router.events
                .pipe(filter(event => event instanceof NavigationEnd))
                .subscribe(() => this.mapTabToRouter())
        );

        this.subscriptions.push(
            combineLatest([this.currentTab, this.currentSubTab])
                .pipe(
                    map(([tab, subTab]) => {
                        const [tabName] = this.location
                            .path()
                            .split('/')
                            .slice(-2);
                        return [tab || tabName, subTab || ''];
                    }),
                    filter(([tab]) => tab !== null),
                    distinctUntilChanged()
                )
                .subscribe(([tab, subTab]) => {
                    // TODO :: this appears to be problem, need to do something with this.
                    if (this.location.path().includes('draft')) {
                        const token = this.route.snapshot.paramMap.get('token');
                        this.tabChangeHandler(tab);
                        this.subTabChangeHandler(subTab);
                        this.router.navigate([`/draft/${token}/${tab}/${subTab}`]);
                    }
                })
        );
        this.subscriptions.push(this.isNotCalibratedReasonService.getAll().subscribe());
    }

    tabChangeHandler(tabName: string) {
        if (this.tabChangeSubject.value !== tabName) {
            this.subTabChangeSubject.next(null);
        }
        this.tabChangeSubject.next(tabName);
    }

    subTabChangeHandler(subTabName: string) {
        this.subTabChangeSubject.next(subTabName);
    }

    private mapTabToRouter() {
        const [tabName, subTabName] = this.location
            .path()
            .split('/')
            .slice(-2);
        this.tabChangeSubject.next(tabName);
        this.subTabChangeSubject.next(subTabName);
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(subscription => !subscription.closed && subscription.unsubscribe());
    }
}
